import { render } from "./SeatAndTripTypeViewer.vue?vue&type=template&id=5cd4555c"
import script from "./SeatAndTripTypeViewer.vue?vue&type=script&lang=js"
export * from "./SeatAndTripTypeViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__